var path = 'receipts/receipt/receipt.tpl.html';
var html = "<div class=\"sbsf-purchase-receipt col-xs-12\">\n  <div class=\"spanning-brand receipt-content\">\n    <div ng-bind-html=\"receiptMarkup\"></div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;